/**
 * Transpose a 2D array.
 *
 * @param matrix 2D array
 */
export const transpose = <T>(matrix: T[][]) => matrix[0].map((_, colIndex) => matrix.map((row) => row[colIndex]));
